import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// style
require('../style/style.scss');

let app = document.getElementById('app');
if (!app){
    app = document.createElement('div');
    app.id = 'app';
    document.body.appendChild(app);
}

const root = createRoot(app);
root.render(<App />);
